import { useState, useEffect, useCallback } from 'react';
import {
  getSubmissions,
  ICandidateSubmissionSearchFilterVM,
  ISubmissionsAPIResponse,
} from 'wisestep-api';

import { getCandidatePorfileMap } from '../../../../features/candidates/talentpool/hooks/useTalentPoolSearch';
import { getUpdatedquery } from '../../utils/Helper';

const useSubmissionsNewContext = (
  query: ICandidateSubmissionSearchFilterVM,
  getProfileImages = false
) => {
  const [submissions, setSubmissions] = useState<ISubmissionsAPIResponse>();
  const [loader, setLoader] = useState<boolean>(false);

  const fetchCandidates = useCallback(async () => {
    setLoader(true);
    try {
      const updatedQuery = getUpdatedquery(query);
      const response = await getSubmissions({ ...updatedQuery });

      const submissionsData = response.data;
      let enrichedCandidates = submissionsData.content;
      if (submissionsData) {
        if (getProfileImages) {
          const profileImagesMap = await getCandidatePorfileMap(
            submissionsData.content.map((candidate) => candidate.candidateId)
          );

          enrichedCandidates = submissionsData.content.map((candidate) => ({
            ...candidate,
            profileImage: profileImagesMap[candidate.candidateId] ?? null,
          }));
        }
        setSubmissions({ ...submissionsData, content: enrichedCandidates });
      }
    } catch (e) {
      console.error('Error in fetching submissions');
    } finally {
      setLoader(false);
    }
  }, [getProfileImages, query]);

  useEffect(() => {
    fetchCandidates();
  }, [fetchCandidates]);

  return {
    submissions: submissions ?? ({} as ISubmissionsAPIResponse),
    refetch: fetchCandidates,
    setSubmissions,
    loader,
  };
};

export default useSubmissionsNewContext;
